var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3Teacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 281,
    viewBox: "0 0 391 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.584 236.547C250.165 248.31 226.464 213.314 142.464 243.181C75.4819 266.994 38.1179 225.027 24.7714 197.343C18.399 184.115 8.48608 129.967 46.239 123.005C174.354 99.339 254.364 -58.2676 336.446 54.728C369.74 100.568 428.122 209.824 304.584 236.547Z",
    fill: "#FFFAF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.59 51.1455H79.5164C74.194 51.1455 69.8794 55.4601 69.8794 60.7825V177.997C69.8794 183.319 74.194 187.634 79.5164 187.634H312.59C317.912 187.634 322.227 183.319 322.227 177.997V60.7825C322.227 55.4601 317.912 51.1455 312.59 51.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.425 49.5088H69.6811C67.3531 49.5088 65.4659 51.396 65.4659 53.7239V57.0795C65.4659 59.4075 67.3531 61.2947 69.6811 61.2947H322.425C324.753 61.2947 326.641 59.4075 326.641 57.0795V53.7239C326.641 51.396 324.753 49.5088 322.425 49.5088Z",
    fill: "#6C501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.471 166.806H136.33V169.071H137.471V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.471 162.177H136.33V157.532H137.471V162.177ZM137.471 152.888H136.33V148.243H137.471V152.888ZM137.471 143.614H136.33V138.969H137.471V143.614ZM137.471 134.341H136.33V129.696H137.471V134.341ZM137.471 125.067H136.33V120.423H137.471V125.067ZM137.471 115.778H136.33V111.133H137.471V115.778ZM137.471 106.504H136.33V101.859H137.471V106.504ZM137.471 97.2309H136.33V92.5859H137.471V97.2309Z",
    fill: "url(#paint0_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.471 85.7759H136.33V88.057H137.471V85.7759Z",
    fill: "url(#paint1_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.464 166.806H159.323V169.071H160.464V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.464 162.177H159.323V157.532H160.464V162.177ZM160.464 152.888H159.323V148.243H160.464V152.888ZM160.464 143.614H159.323V138.969H160.464V143.614ZM160.464 134.341H159.323V129.696H160.464V134.341ZM160.464 125.067H159.323V120.423H160.464V125.067ZM160.464 115.778H159.323V111.133H160.464V115.778ZM160.464 106.504H159.323V101.859H160.464V106.504ZM160.464 97.2309H159.323V92.5859H160.464V97.2309Z",
    fill: "url(#paint2_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.464 85.7759H159.323V88.057H160.464V85.7759Z",
    fill: "url(#paint3_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.457 166.806H182.317V169.071H183.457V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.457 162.177H182.317V157.532H183.457V162.177ZM183.457 152.888H182.317V148.243H183.457V152.888ZM183.457 143.614H182.317V138.969H183.457V143.614ZM183.457 134.341H182.317V129.696H183.457V134.341ZM183.457 125.067H182.317V120.423H183.457V125.067ZM183.457 115.778H182.317V111.133H183.457V115.778ZM183.457 106.504H182.317V101.859H183.457V106.504ZM183.457 97.2309H182.317V92.5859H183.457V97.2309Z",
    fill: "url(#paint4_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.457 85.7759H182.317V88.057H183.457V85.7759Z",
    fill: "url(#paint5_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.467 166.806H205.327V169.071H206.467V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.451 162.177H205.31V157.532H206.451V162.177ZM206.451 152.888H205.31V148.243H206.451V152.888ZM206.451 143.614H205.31V138.969H206.451V143.614ZM206.451 134.341H205.31V129.696H206.451V134.341ZM206.451 125.067H205.31V120.423H206.451V125.067ZM206.451 115.778H205.31V111.133H206.451V115.778ZM206.451 106.504H205.31V101.859H206.451V106.504ZM206.451 97.2309H205.31V92.5859H206.451V97.2309Z",
    fill: "url(#paint6_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.467 85.7759H205.327V88.057H206.467V85.7759Z",
    fill: "url(#paint7_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46 166.806H228.32V169.071H229.46V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46 162.177H228.32V157.532H229.46V162.177ZM229.46 152.888H228.32V148.243H229.46V152.888ZM229.46 143.614H228.32V138.969H229.46V143.614ZM229.46 134.341H228.32V129.696H229.46V134.341ZM229.46 125.067H228.32V120.423H229.46V125.067ZM229.46 115.778H228.32V111.133H229.46V115.778ZM229.46 106.504H228.32V101.859H229.46V106.504ZM229.46 97.2309H228.32V92.5859H229.46V97.2309Z",
    fill: "url(#paint8_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46 85.7759H228.32V88.057H229.46V85.7759Z",
    fill: "url(#paint9_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.453 166.806H251.313V169.071H252.453V166.806Z",
    fill: "#89BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.453 162.177H251.313V157.532H252.453V162.177ZM252.453 152.888H251.313V148.243H252.453V152.888ZM252.453 143.614H251.313V138.969H252.453V143.614ZM252.453 134.341H251.313V129.696H252.453V134.341ZM252.453 125.067H251.313V120.423H252.453V125.067ZM252.453 115.778H251.313V111.133H252.453V115.778ZM252.453 106.504H251.313V101.859H252.453V106.504ZM252.453 97.2309H251.313V92.5859H252.453V97.2309Z",
    fill: "url(#paint10_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.453 85.7759H251.313V88.057H252.453V85.7759Z",
    fill: "url(#paint11_linear_93_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.287 168.475L136.33 143.614L160.464 134.341L182.316 148.259L205.326 125.067L228.32 115.778L252.453 92.5859",
    stroke: "#FFD77C",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.48 170.393L113.387 170.377V78.1885H115.288V168.476L275.48 168.492V170.393Z",
    fill: "#6C501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.783 84.6682C109.998 84.817 110.296 84.7509 110.444 84.5194L114.345 78.4033L118.247 84.5194C118.395 84.7343 118.676 84.8004 118.908 84.6682C119.139 84.536 119.189 84.2384 119.057 84.007L114.759 77.2627C114.676 77.1305 114.527 77.0479 114.362 77.0479C114.197 77.0479 114.048 77.1305 113.965 77.2627L109.667 84.007C109.667 84.007 109.601 84.1723 109.601 84.255C109.601 84.4037 109.684 84.569 109.816 84.6517L109.783 84.6682Z",
    fill: "#6C501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 173.997C268.851 173.782 268.917 173.484 269.149 173.336L275.265 169.435L269.149 165.533C268.934 165.385 268.868 165.104 269 164.872C269.132 164.641 269.43 164.591 269.661 164.723L276.406 169.021C276.538 169.104 276.62 169.253 276.62 169.418C276.62 169.583 276.538 169.732 276.406 169.815L269.661 174.113C269.661 174.113 269.496 174.179 269.413 174.179C269.265 174.179 269.099 174.096 269.017 173.964L269 173.997Z",
    fill: "#6C501A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_436",
    x: 45.4659,
    y: 33.5088,
    width: 301.175,
    height: 178.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_436",
    x1: 136.901,
    y1: 92.5859,
    x2: 136.901,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_436",
    x1: 136.901,
    y1: 85.7759,
    x2: 136.901,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_93_436",
    x1: 159.894,
    y1: 92.5859,
    x2: 159.894,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_93_436",
    x1: 159.894,
    y1: 85.7759,
    x2: 159.894,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_93_436",
    x1: 182.887,
    y1: 92.5859,
    x2: 182.887,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_93_436",
    x1: 182.887,
    y1: 85.7759,
    x2: 182.887,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_93_436",
    x1: 205.881,
    y1: 92.5859,
    x2: 205.881,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_93_436",
    x1: 205.897,
    y1: 85.7759,
    x2: 205.897,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_93_436",
    x1: 228.89,
    y1: 92.5859,
    x2: 228.89,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_93_436",
    x1: 228.89,
    y1: 85.7759,
    x2: 228.89,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_93_436",
    x1: 251.883,
    y1: 92.5859,
    x2: 251.883,
    y2: 162.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_93_436",
    x1: 251.883,
    y1: 85.7759,
    x2: 251.883,
    y2: 88.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Teacher);
export default __webpack_public_path__ + "static/media/step3_teacher.e8dfc26317ffd6cf0cb0aea787638662.svg";
export { ForwardRef as ReactComponent };